module.exports = __webpack_public_path__ + "static/media/cloud-rainbow.df73dfeb.svg";